import type React from 'react';
import { createContext } from 'react';

import type { Conversation, Message } from '@/features/ai-chat/types/chat.types';

export interface ChatState {
  messages: Message[];
  inputMessage: string;
  conversationId: string | null;
  version: number;
  animatedHumanId?: string | null;
  animatedText?: string | null;
  isInitializing: boolean;
  isSending: boolean;
}

export interface ChatActions {
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
  setInputMessage: React.Dispatch<React.SetStateAction<string>>;
  handleSend: () => void;
  sendMessage: (text: string, options?: { addHuman?: boolean }) => void;
  setConversationId: (conversationId: string | null) => void;
  restoreConversation: (conversation: Conversation) => void;
  onAnimatedComplete?: () => void;
}

export type ChatContextValue = ChatState & ChatActions;

export const ChatStateContext = createContext<ChatState | undefined>(undefined);
export const ChatActionsContext = createContext<ChatActions | undefined>(undefined);
